/**
=========================================================
* Soft UI Dashboard React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";

import { useSoftUIController } from "context";

// Soft UI Dashboard React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Dashboard layout components
import UnassignedDrivers from "layouts/users/components/UnassignedDrivers";

function Drivers() {
  const [controller, dispatch] = useSoftUIController();
  const { drivers, deliveries, pickups, selectedDriver } = controller;

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <UnassignedDrivers drivers={drivers} deliveries={deliveries} pickups={pickups} selectedDriver={selectedDriver} />
            </Grid>
          </Grid>
        </SoftBox>              
      </SoftBox>
    </DashboardLayout>
  );
}

export default Drivers;
